import React, { PureComponent } from 'react';
import styled from 'styled-components';

import Header from '~/components/Header';
import Search from '~/components/Search';
import Footer from '~/components/Footer';
import Visualisation from '~/components/Visualisation';
import FilterButtons from '~/components/FilterButtons';
import Infobox from '~/components/Infobox';

const AppWrapper = styled.div`
  position: relative;
  max-width: 700px;
  margin: 0 auto;
  padding: 0 15px;
`;

class App extends PureComponent {
  render() {
    return (
      <>
        <AppWrapper>
          <Header />
          <Search />
          <Visualisation />
          <FilterButtons />
          <Footer />
        </AppWrapper>
        <Infobox />
      </>
    );
  }
}

export default App;
